import React, { Component } from 'react';
import { Row, Col, Button, Popover, Modal, message ,Collapse,Drawer,Alert,Empty,Tree, Input ,Form,Select,Upload,Icon } from 'antd';
import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import $ from "jquery"
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import createHistory from 'history/createHashHistory';//路由切换地址
const { Panel } = Collapse;
const { TreeNode } = Tree;
const { Search } = Input;
const FormItem = Form.Item;
const { TextArea } = Input;
import "./style.css"//引入样式

const history = createHistory();//定义history路由
const confirm = Modal.confirm;


const x = 3;
const y = 2;
const z = 1;
const gData = [];

const generateData = (_level, _preKey, _tns) => {
  const preKey = _preKey || '0';
  const tns = _tns || gData;

  const children = [];
  for (let i = 0; i < x; i++) {
    const key = `${preKey}-${i}`;
    tns.push({ title: key, key });
    if (i < y) {
      children.push(key);
    }
  }
  if (_level < 0) {
    return tns;
  }
  const level = _level - 1;
  children.forEach((key, index) => {
    tns[index].children = [];
    return generateData(level, key, tns[index].children);
  });
};
generateData(z);

const dataList = [];
const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const { key } = node;
    dataList.push({ key, title: key });
    if (node.children) {
      generateList(node.children);
    }
  }
};
generateList(gData);

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

var filePath = ''
var _classManage = null
class ClassManage extends React.Component{
    state={
        visible:false,
        expandedKeys: [],
        searchValue: '',
        autoExpandParent: true,
        dataName: '',
        fileList: [],
    };
    componentDidMount(){
        _classManage = this
    };
    onClose=()=>{
        this.setState({
            visible:false
        })
    }
    onExpand = expandedKeys => {
        this.setState({
          expandedKeys,
          autoExpandParent: false,
        });
      };
    
      onChange = e => {
        const { value } = e.target;
        const expandedKeys = dataList
          .map(item => {
            if (item.title.indexOf(value) > -1) {
              return getParentKey(item.key, gData);
            }
            return null;
          })
          .filter((item, i, self) => item && self.indexOf(item) === i);
        this.setState({
          expandedKeys,
          searchValue: value,
          autoExpandParent: true,
        });
      };
      onSelect = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
      };
    
      onCheck = (checkedKeys, info) => {
        console.log('onCheck', checkedKeys, info);
      };
      handleChange = (info) => {  //文件上传方法
        // console.log(info.file.type)
        let fileList = info.fileList;
        if (info.file.status != "error") {
            if (info.file.status == "done") {
                message.success(`${info.file.name} 文件上传成功`);

                // if(file.response && file.response.indexOf('false') != -1){
                //     message.error(`${file.name} 文件上传失败`);
                //     let fileList_back = this.state.fileList.filter(item => item.uid != file.uid)
                //     this.setState({ fileList:fileList_back })
                //     return
                // }else{
                //     message.success(`${file.name} 文件上传成功`);
                // }

            } else {
                if (info.file.status == "removed") {
                    message.success(`${info.file.name} 文件移除成功`);
                }
            }
            fileList = fileList.map((file) => {
                if (file.response) {
                    file.url = file.response;
                }
                return file;
            });

            if (info.file.size < 20971520 || info.file.size == null) {
                filePath = fileList;
                _classManage.setState({ fileList: filePath });
            } else {
                filePath = _classManage.state.fileList
                _classManage.setState({ fileList: filePath });
            }

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
        }

    }
    //上传前置事件
    beforeUpload = (file) => {
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            message.error('单个附件大小最多20M');
            return false
        } else if(file.type.search("image/") == '-1'){
            message.error('请上传正确格式的图片');
            return false
        } else {
            this.setState({ dataName: file.name })
        }
        return true;
    }
    render(){
        const head = { 'X-Requested-With': null }
        const { getFieldDecorator } = this.props.form;
        const { searchValue, expandedKeys, autoExpandParent } = this.state;
        const loop = data =>
          data.map(item => {
            const index = item.title.indexOf(searchValue);
            const beforeStr = item.title.substr(0, index);
            const afterStr = item.title.substr(index + searchValue.length);
            const title =
              index > -1 ? (
                <span>
                  {beforeStr}
                  <span style={{ color: '#f50' }}>{searchValue}</span>
                  {afterStr}
                </span>
              ) : (
                <span>{item.title}</span>
              );
            if (item.children) {
              return (
                <TreeNode key={item.key} title={title}>
                  {loop(item.children)}
                </TreeNode>
              );
            }
            return <TreeNode key={item.key} title={title} />;
          });
        return (
            <div>
               <Drawer
                title="退货品类管理"
                placement="right"
                onClose={this.onClose}
                visible={this.state.visible}
                width={720}
                >
                <Alert message="请通过支付宝或银联申请相应资金账户，通过后按如下表单要求填写" type="info" showIcon />
                <div style={{fontSize:'14px',color:'#333',margin:'24px 0'}}>步骤一：品类选择</div>
                <div style={{height:'400px',overflowY:'auto',padding:'24px',border:'1px solid #f2f2f2'}}>
                    <Search style={{ marginBottom: 8 }} placeholder="关键字搜索" onChange={this.onChange} />
                    <Tree
                    onExpand={this.onExpand}
                    expandedKeys={expandedKeys}
                    autoExpandParent={autoExpandParent}
                    checkable
                    onSelect={this.onSelect}
                    onCheck={this.onCheck}
                    >
                    {loop(gData)}
                    </Tree>
                </div>
                <div style={{fontSize:'14px',color:'#333',margin:'24px 0'}}>步骤二：已选品类维护，共 4 项</div>
                <Form  className='formSearch' style={{ marginLeft: 10,paddingBottom:'80px' }}>
                    <div style={{border:'1px solid #f2f2f2'}}>
                        <div style={{borderBottom:'1px solid #f2f2f2',height:'40px',lineHeight:'40px',paddingLeft:'24px'}}>A:树节点名称</div>
                        <div style={{padding:'24px'}}>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="承诺退货时效"
                                >
                                    {getFieldDecorator('result' ,{
                                        initialValue:'7',
                                    rules: [
                                        { required: true, message: '请选择承诺退货时效' },
                                    ],
                                })(
                                            <Select placeholder='请选择承诺退货时效' >
                                                <Option value="7">7天</Option>
                                                <Option value="10">10天</Option>
                                                <Option value="15">15天</Option>
                                                <Option value="30">30天</Option>
                                                <Option value="60">60天</Option>
                                                <Option value="100">100天</Option>
                                                <Option value="180">180天</Option>
                                            </Select>
                                    )}
                                </FormItem>
                            </Col>
                           

                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="注意事项"
                                >
                                    {getFieldDecorator('noticeContent' ,{
                                    rules: [
                                        { required: false, message: '请输入注意事项' },
                                    ],
                                })(
                                    <TextArea autosize={{ minRows: 3, maxRows: 4 }} size='small' placeholder='请输入拒绝原因，400字内，必填' maxLength={400} />  
                                    )}
                                </FormItem>
                            </Col>
                           

                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                            <FormItem
                                        label=""
                                    >
                                        {getFieldDecorator('CP_Attach', {
                                            rules: [{ required: false, message: '请输入办理内容' }],
                                        }
                                        )(
                                         <Upload
                                                name="file"
                                                // action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                fileList={this.state.fileList}
                                                headers={head}
                                              
                                            ><Button disabled={ this.state.fileList.length >= 4?true:false}>
                                                    <Icon type="upload" /> 附件上传
                                            </Button> 
                                </Upload> )}
                                    </FormItem>
                            </Col>
                           

                        </Row>
                        </div>
                    </div>
                </Form>
                

                <div style={{position:"absolute",right:'0',bottom:'0',height:'50px',width:'100%',padding:'0 24px',lineHeight:'50px',borderTop:'1px solid #f2f2f2',background:"#fff"}}>
                    <Button style={{float:'right',marginTop:'10px'}} type="primary">提交送审</Button>
                    <Button onClick={this.onClose} style={{float:'right',marginRight:'8px',marginTop:'10px'}}>取消</Button>
                </div>
                </Drawer>

            </div>
        )
    }
}
const ClassManageWrapper = Form.create()(ClassManage);

//Tab--企业介绍组件
let _TabIntroduce = null;
class TabIntroduce extends React.Component {
    state = {
        visible: false,
        type: 1,
        data: [],
        classData:[],
        numbers:0,
        activeKey:[],
        noticeText:'',
    };

    //组件完成
    componentDidMount() {
       
        _TabIntroduce = this
        this.getClass()
    }
    showClass=()=>{
        _classManage.setState({
            visible:true
        })
    }
    getClass=()=>{
      let setData = {
        UserCode: EventSet.getUserInfo().CU_Code, 
        CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code, 
      };
      $.ajax({
        url: Hcurl+"/CompanyCore/GetCompanySort",
        type: "post",
        data: setData,
        async: false,
        headers: {
            "token": EventSet.getUserInfo()['token']
        },
        success: function (res) {
            console.log('344',JSON.parse(res))
            _TabIntroduce.setState({
              classData:JSON.parse(res).Rows,
              numbers:(JSON.parse(res).TotalCount!=null&&JSON.parse(res).TotalCount!='')?JSON.parse(res).TotalCount:0,
              activeKey:JSON.parse(res).Rows.map((item)=>{
                return item.CateCode
              }),
              noticeText:JSON.parse(res).Rows.length>0?JSON.parse(res).Rows[0].Com_Comment:''
            })
            
            // _this.setInitialValue(JSON.parse(res))
        },
        error: function (data, err) {
            // if (!JSON.parse(data.responseText).success && data.status === 403) {
            //     history.push({ "pathname": "/err" })
            // } else {
            //     message.error(err)
            // }
        }
    })
    }
    changeTab=(e)=>{
      console.log('364',e)
      this.setState({
        activeKey:e
      })
    }
    render() {
        return (
            <div className={"TabIntroduce"}>
                {/* <div className=""><Button type="primary" onClick={this.showClass}>退货品类管理</Button></div> */}
              <div style={{fontSize:'14px',color:'#333',margin:'24px 0'}}>退货品类，共<span style={{fontSize:'14px',color:'#108EE9',fontWeight:500}}>{this.state.numbers}</span>项</div>
                {this.state.classData.length>0?<Collapse activeKey={this.state.activeKey} onChange={this.changeTab} style={{width:'80%'}}>
                  {this.state.classData.map((item)=>{
                    return <Panel header={item.CateAllName+' ('+item.ComPromiseTime+')'} key={item.CateCode}>
                          <p>注意事项</p>
                          <p>{item.ComRemark!=null?item.ComRemark:'-'}</p>
                          <p>商品图片</p>
                          {(item.ComPicture!=''&&item.ComPicture!=null)?(item.ComPicture.split(';')).map((si,index)=>{
                            if(si!=''){
                              return <img style={{width:'60px' ,height:'60px',borderRadius:'5px',marginRight:'10px'}} src={si} key={index}/>
                            }
                            
                          }):'-'}
                          
                          </Panel>
                  })}

                </Collapse>:<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                
                <div style={{fontSize:'14px',color:'#333',margin:'24px 0'}}>告知说明</div>
                {this.state.noticeText!=''?<p>{this.state.noticeText}</p>:<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                <ClassManageWrapper/>
            </div>
        )

    }

}

export default TabIntroduce


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyListTab/TabIntroduce.js